export default __webpack_public_path__ + "static/media/step7.5a2718d5.png";